import React, { createContext, useState } from "react";

export const SearchRoleContext = createContext({});

const SearchRoleProvider = ({ children }) => {
  const [searchValues, setSearchValues] = useState({
    roleName: "",
    permissionId: "",
  });
  const [pageValues, setPageValues] = useState({
    page: 0,
    pageSize: 10,
    sortBy: "roleNameTh", //(ex. roleNameTh, description, recStatus)
    sortDirection: "DESC",
  });
  const [fetchData, setFetchData] = useState(true);

  return (
    <SearchRoleContext.Provider
      value={{
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        fetchData,
        setFetchData,
      }}
    >
      {children}
    </SearchRoleContext.Provider>
  );
};

export default SearchRoleProvider;
